<template>
  <div class="d-flex flex-column gap-2 my-2">
    <BaseTotal
      id="total-price"
      :price="props.totalPrice"
      :title="t('payments.totalPrice')"
    />
    <BaseTotal
      v-if="props.totalPaid && props.totalPaid !== props.totalPrice"
      id="total-paid"
      :price="props.totalPaid"
      :title="t('payments.totalPaid')"
    />
    <BaseTotal
      v-if="props.depositToPay && props.depositToPay > 0"
      id="deposit-to-pay"
      :price="props.depositToPay"
      :title="t('payments.depositToPay')"
    />
    <BaseTotal
      v-if="props.leftToPay"
      id="balance"
      :price="props.leftToPay"
      :title="t('payments.leftToPay')"
      :text-class="'body-strong text-grey-900'"
    />
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { defineProps } from 'vue'

  // Components
  import BaseTotal from './BaseTotal.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Props
  interface Props {
    totalPrice: number
    leftToPay?: number
    depositToPay?: number | null
    totalPaid?: number
    isQuoteOrCartInProgress: boolean
  }

  const props = defineProps<Props>()
</script>
